import logo from '@/assets/images/logo.svg';
import { cn } from '@/utils/utils';
import { useTranslation } from 'react-i18next';

interface BackgroundPanelProps {
    className?: string
}

export default function BackgroundPanel({ className }: BackgroundPanelProps) {
    // hooks
    const { t } = useTranslation();

    return (
        <div className={cn('flex flex-col justify-center items-center gap-4', className)}>
            <img src={logo} alt='' className='w-1/2 h-auto object-contain'></img>
            <div className='text-2xl font-bold text-black'>{t('words_title.welcome_cms')}</div>
        </div>
    );
}
